import React, { useContext, useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import MainLayout from "../layouts/MainLayout"

const PrivateRoute = ({ noLayout = false, children }) => {
  const { bearerToken, setRedirectPath } = useContext(AuthContext);
  const location = useLocation();
  const [isAuthenticating, setIsAuthenticating] = useState(true);

  useEffect(() => {
    if (!bearerToken) {
      setRedirectPath(location.pathname); // Salva a rota para redirecionamento
    }
    setIsAuthenticating(false); // Finaliza verificação de autenticação
  }, [bearerToken, location.pathname, setRedirectPath]);

  if (isAuthenticating) {
    // Exibe um spinner ou mensagem enquanto verifica autenticação
    // return <Box display="flex" justifyContent="center" alignItems="center" height="100%">
    //   <CircularProgress />
    // </Box>;
  }

  if (!bearerToken) {
    // Redireciona para login se não autenticado
    return <Navigate to="/login" />;
  }

  // Renderiza rotas protegidas com ou sem layout
  return noLayout ? children : <MainLayout><Outlet /></MainLayout>;
};

export default PrivateRoute;
